import axios from "axios";
import React from "react";
import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Redirect, useParams } from "react-router-dom";
import GetActiveLcdData from "../common/getActiveLcdData";
import { getHeaderForAxios } from "../common/getLocalStorageData";
import { IReduxStateData } from "../interfaces/redux";
import TeamImageTitleHoriz from "../components/image/teamImageTitleHoriz";
import { deal_type } from "../constant/deal";

interface IPageData {
    "teams_data": any
}
let initialData = {
    "teams_data": []
}
const Teams = () => {
    const [pageDetail, setPageDetail] = useState<IPageData>(initialData);
    const [redirectToNotFound, setRedirectToNotFound] = useState(false)
    const globalState = useSelector((state: IReduxStateData) => state);
    useEffect(() => {
        let globalStateData = GetActiveLcdData(globalState);
        if (globalStateData && globalStateData.tp_identifier && globalStateData.is_player === deal_type['teams_deal']) {
            let identifierList = globalStateData.tp_identifier.split(",")
            let postData = {
                "teams_identifier": identifierList || []
            }
            axios.post(process.env.REACT_APP_API_URL + '/match/getTeamsDetail', postData, { headers: getHeaderForAxios() })
                .then(function (response) {
                    if (response.data.success) {
                        setPageDetail(response.data.success)
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
        }
        else {
            setRedirectToNotFound(true)
        }
    }, [])
    return (
        redirectToNotFound ? <Redirect to='/404' />
            :
            <React.Fragment>
                <section className="similar-player theme-light-white m-0 py-4">
                    <Container className="theme-light-white">
                        <div className="row py-2">
                            {pageDetail.teams_data && pageDetail.teams_data.map((element, index) => (
                                <div className="col-12 col-md-6 col-lg-4 pt-2">
                                    <TeamImageTitleHoriz {...element} />
                                </div>
                            ))}
                        </div>
                    </Container>
                </section>
            </React.Fragment>
    )
}

export default Teams;
